/** When set, show sidebar link to classic POS at `/pos-v1` (set `VITE_POS_V2=1` in `.env`). */
export const POS_V2_ENABLED = import.meta.env.VITE_POS_V2 === "1";
